/** @jsx jsx */
import { Button, jsx } from "theme-ui";
import React, { useRef, useState } from "react";
import {
  containerStyles,
  imageStyles,
  overlayOpenStyles,
  overlayStyles,
  playIconStyles,
  VideoWrapperStyles,
} from "./styles";
import PlayIcon from "@svg-icons/youtube-play.component.svg";
import { Image } from "@shared-components/Image/Image";
import LazyLoad from "react-lazyload";
import { Container } from "@shared-components/Container/Container";
import { AspectRatio } from "@shared-components/AspectRatio/AspectRatio";
import { UmbracoImage } from "@shared-components/Image/UmbracoImage/UmbracoImage";
import { Box } from "../../shared/components/Box/Box";
import { VideoEmbedModule } from "../../carlsberg-headless/types/modules/VideoEmbed";

import YouTube, { YouTubeProps } from "react-youtube";
import { YouTubePlayer } from "youtube-player/dist/types";

export type VideoEmbedProps = VideoEmbedModule;

const VideoEmbed: React.FC<VideoEmbedProps> = ({ cbKey, youTubeId, image }) => {
  const video = useRef<YouTubePlayer>();
  const [firstPlay, setFirstPlay] = useState<boolean>(true);
  const [playing, setPlaying] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const overlayImageUrl = `https://img.youtube.com/vi/${youTubeId}/maxresdefault.jpg`;

  const playPause = () => {
    if (video.current) {
      if (playing) {
        video.current.pauseVideo();
        setPlaying(false);
      } else {
        video.current.playVideo();
        setPlaying(true);

        if (firstPlay) {
          setFirstPlay(false);
        }
      }
    }
  };

  const _onReady = (event: any) => {
    video.current = event.target;
  };
  const _onEnd = () => {
    setPlaying(false);
    setFirstPlay(true);
  };

  const opts = {
    width: "100%",
    host: "https://www.youtube-nocookie.com",
    playerVars: {
      rel: 0,
      controls: 0,
    },
  } as YouTubeProps;

  if (!youTubeId) return null;

  return (
    <Container key={cbKey}>
      <div ref={containerRef} sx={containerStyles}>
        <AspectRatio ratio="16:9" sx={{ zIndex: 1 }}>
          <Button
            onClick={() => playPause()}
            sx={{
              ...overlayStyles,
              ...(!firstPlay && { background: "none" }),
              ...(!firstPlay && !playing && overlayOpenStyles),
            }}
          >
            {firstPlay && image && (
              <UmbracoImage
                image={image}
                width={[496, 913, 1280]}
                alt={image.altText ?? ""}
                sx={imageStyles(playing)}
                isCover
              />
            )}
            {firstPlay && !image && (
              <LazyLoad once offset={-150}>
                <Image sx={imageStyles(playing)} src={overlayImageUrl} alt="" />
              </LazyLoad>
            )}
            <PlayIcon sx={playIconStyles(playing)} />
          </Button>
          <Box sx={VideoWrapperStyles}>
            <YouTube
              videoId={youTubeId}
              onReady={(e) => _onReady(e)}
              onPlay={() => !firstPlay && setPlaying(true)}
              onEnd={() => _onEnd()}
              opts={opts}
            />
          </Box>
        </AspectRatio>
      </div>
    </Container>
  );
};

export { VideoEmbed };
